module.exports = __webpack_public_path__ + "static/media/pyramidImg2.bde00d95.webp";